import React from "react";
import styled from "styled-components";

// Phase A.5 v2: positioned absolute at the bottom of the hero so it
// doesn't compete for flex-row space with the centered hero column.
const MyScroll = styled.div`
  position: absolute;
  left: 50%;
  bottom: 2rem;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  justify-content: center;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.4);
  font-family: "JetBrains Mono", "Roboto Mono", monospace;
  font-size: 0.7rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  pointer-events: none;
  animation: scrollHint 2.4s ease-in-out infinite;

  .turn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
  }

  .arrow {
    width: 1px;
    height: 28px;
    background: linear-gradient(
      to bottom,
      transparent 0%,
      rgba(34, 211, 238, 0.7) 100%
    );
  }

  @keyframes scrollHint {
    0%, 100% { opacity: 0.6; transform: translateX(-50%) translateY(0); }
    50% { opacity: 1; transform: translateX(-50%) translateY(4px); }
  }
`;

const ScrollDown = () => {
  return (
    <MyScroll aria-hidden="true">
      <div className="turn">
        <span>scroll</span>
        <span className="arrow" />
      </div>
    </MyScroll>
  );
};

export default ScrollDown;
